import Vue from 'vue'
import Router from 'vue-router'
import e404 from '@/views/error/404.vue'
import e500 from '@/views/error/500.vue'
import Unauthorized from '@/views/error/Unauthorized.vue'

var router = new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/error/404',
            name: '404 Error',
            component: e404
        },
        {
            path: '/error/500',
            name: '500 Error',
            component: e500
        },
        {
            path: '/error/unauthorized',
            name: 'Unauthorized',
            component: Unauthorized
        },
        {
            path: '*',
            beforeEnter(route) { window.location.href = route.path }
        }
    ]
})

Vue.use(Router)
export default router
